import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { revokeToken } from '../../../utils/session-utils';

const useStyles = makeStyles({
  root: {
    display: 'block',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 16px',
    width: '100%',
    maxWidth: '340px'
  },
  button: {
    display: 'block',
    background: '#fff',
    color: '#1e69d2',
    borderRadius: '3px',
    padding: '8px 48px',
    height: '40px',
    width: '100%'
  },
  error: {
    fontSize: '14px'
  }
});

const TwistleButton = ({ locale, userProvision, onSuccess }) => {
  const classes = useStyles();
  const [isTwistleBtnDisabled, setIsTwistleBtnDisabled] = useState(false);
  const [error, setError] = useState(null);

  const twistleBtnClicked = () => {
    setIsTwistleBtnDisabled(true);
    userProvision(
      { locale: locale.id },
      () => {
        revokeToken();
        onSuccess();
      },
      err => {
        setError(err);
        setIsTwistleBtnDisabled(false);
      }
    );
  };

  return (
    <div className={classes.root}>
      {error && <span className={classes.error}>{error}</span>}
      <Button
        id="send-form-btn"
        className={classes.button}
        color="inherit"
        variant="contained"
        onClick={twistleBtnClicked}
        disabled={isTwistleBtnDisabled}
      >
        {locale.button_labels.continue}
      </Button>
    </div>
  );
};

export default TwistleButton;
